module.exports = __webpack_public_path__ + "static/media/kantoushan_mobile.01d6c5ad.png";